import appAxios from '@/axios/appAxios';
export default{
    namespaced:true,
    state:{
        list:null
    },
    getters:{
        getList(state){
            return state.list
        }
    },
    mutations:{
        setList(state,list){
            state.list=list
        },deleteItem(state, id) {
            state.list= state.list.filter((l) => l.id !== id);
        },
        updateItem(state, updateitem) { 
            var item = state.list.find((l) => l.id === updateitem?.id);
            item.longUrl=updateitem.longUrl;
        }
    },
    actions:{
        async fetchList(context,{userid,type}){
            if(type!=2){
                await appAxios.get('/Link?userId='+userid).then((result)=>{
                    context.commit('setList',result.data)
                })
            }else{
                console.log('Get All Çaşıştı')
                await appAxios.get('/Link/getAllUser').then((result)=>{
                    context.commit('setList',result.data)
                })
            }
          
        },
        async deleteItem(context,id){
           return await appAxios.delete(`/Link/${id}`)
        },
        async updateItem(context,item){
            
            return await appAxios.put(`/Link/${item.id}`,{
                longUrl:item.longUrl
            });
        }
    }
};
